import { styled } from '@defa/defa-component-library';

export const IconContainer = styled.div`
    display: flex;
    flex: 1;
    justify-content: center;
`;

export const IOSDownload = styled.a`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 200px;
    height: 50px;
    background-image: url('/images/download-ios.svg');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    border: none;
    text-decoration: none;
    cursor: pointer;
`;

export const AndroidDownload = styled.a`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 200px;
    height: 50px;
    background-image: url('/images/download-android.png');
    background-size: contain;
    background-position: center;
    background-repeat: no-repeat;
    border: none;
    text-decoration: none;
    cursor: pointer;
`;

// Group's fixed 48px margins leave a phone very little room, so the form keeps them only on
// wider screens. 600px matches Screen's own breakpoint.
export const FormContainer = styled.div`
    width: 100%;
    max-width: calc(480px + ${({ theme }) => theme.spacing(24)});
    box-sizing: border-box;
    padding: ${({ theme }) => `${theme.spacing(12)} ${theme.spacing(12)} ${theme.spacing(13)}`};

    @media (max-width: 600px) {
        padding: ${({ theme }) => `${theme.spacing(6)} ${theme.spacing(2)}`};
    }
`;

// On a phone a third of the row is too narrow for "flag +46 SE", so the country takes the
// width it needs and the phone number the rest.
export const PhoneRow = styled.div`
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: ${({ theme }) => theme.spacing(2)};

    @media (max-width: 600px) {
        grid-template-columns: max-content 1fr;
    }
`;
